import I18n from 'I18n';
import { useSelector } from 'react-redux';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { CONTACT } from 'self-service-api/constants/UnitTypes';
import UICheckoutButton from 'ui-addon-upgrades/button/UICheckoutButton';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { productBasedOfferIdsWithMandatorySkuSelector } from '../../../selectors/ProductBasedOffersSelectors';
import { checkoutProductConfigurationsForSeatsSelector, productVersionFromConfigsSelector } from '../../../selectors/ProductConfigsSelectors';
import { productsFromProductInventoryQuantityPackQuantitySelector } from '../../../selectors/ProductInventorySelectors';
import { quantityPackForProductVersionSelector, rawProductListSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const InterstitialMarketingContactsPurchaseMotionButton = ({
  upgradeData,
  offerProductConfigurations,
  nonRecurringProductConfigurations = [],
  productConfigurations = [],
  onClick
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const rawProductList = useSelector(rawProductListSelector);
  const checkoutProductConfigurations = useAppSelector(state => checkoutProductConfigurationsForSeatsSelector(state, {
    productConfigurations
  }));
  const marketingProduct = useAppSelector(state => productVersionFromConfigsSelector(state, {
    productConfigurations,
    productLine: MARKETING
  }));
  const quantityPack = useSelector(state => marketingProduct && quantityPackForProductVersionSelector(state, {
    productVersionSkuId: marketingProduct.skuId,
    unitScope: MARKETING,
    unitType: CONTACT
  }));
  const ownedQuantityPackQuantity = useAppSelector(state => marketingProduct && productsFromProductInventoryQuantityPackQuantitySelector(state, {
    productIdentifier: {
      apiName: marketingProduct.productApiName
    },
    unitScope: MARKETING,
    unitType: CONTACT
  }));
  const productBasedOffers = useSelector(state => productBasedOfferIdsWithMandatorySkuSelector(state, {
    skuIds: checkoutProductConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const quantityPackConfig = productConfigurations.find(({
    skuId
  }) => skuId === (quantityPack && quantityPack.skuId));
  const disabled = !quantityPackConfig || ownedQuantityPackQuantity !== null && quantityPackConfig.quantity <= ownedQuantityPackQuantity;
  return /*#__PURE__*/_jsx(UICheckoutButton, {
    "data-selenium-id": "checkout-button",
    offerProductConfigurations: offerProductConfigurations,
    nonRecurringProductConfigurations: nonRecurringProductConfigurations,
    currencyCode: currencyCode,
    disabled: disabled,
    upgradeData: upgradeData,
    products: rawProductList,
    shouldShowErrorAlert: true,
    productBasedOffers: productBasedOffers,
    use: 'primary',
    onClick: onClick,
    children: I18n.text(`interstitial.continueCta`)
  });
};
export default InterstitialMarketingContactsPurchaseMotionButton;